/**
 * Single source of truth for checkout payment methods.
 * Keep MoyasarPaymentForm + PaymentMethods in sync.
 */

/** Card networks passed to Moyasar supported_networks */
export const MOYASAR_CARD_NETWORKS = [
  'mada',
  'visa',
  'mastercard',
  'amex',
  'unionpay',
]

/**
 * Moyasar form methods. Add 'applepay' / 'stcpay' when enabled in Moyasar dashboard.
 * Apple Pay also needs domain verification on live site.
 */
export const MOYASAR_METHODS = ['creditcard']

/** Human-readable summary for UI copy */
export const PAYMENT_SUMMARY =
  'Mada, Visa, Mastercard, Amex, UnionPay & other major cards — plus Tamara'

/** Badges shown in footer / cart / checkout */
export const PAYMENT_BADGES = [
  { id: 'mada', label: 'mada', title: 'Mada', className: 'pay-badge--mada' },
  { id: 'visa', label: 'VISA', title: 'Visa', className: 'pay-badge--visa' },
  {
    id: 'mastercard',
    label: 'Mastercard',
    title: 'Mastercard',
    className: 'pay-badge--mastercard',
    icon: 'mastercard',
  },
  { id: 'amex', label: 'AMEX', title: 'American Express', className: 'pay-badge--amex' },
  { id: 'unionpay', label: 'UnionPay', title: 'UnionPay', className: 'pay-badge--unionpay' },
  { id: 'tamara', label: 'tamara', title: 'Tamara — Buy now, pay later', className: 'pay-badge--tamara' },
]
